module.exports = __webpack_public_path__ + "static/media/it.15a1f288.svg";